<template>
    <div class="check-step-item check-step-item-3">
        <ConfirmWindow text="Вы уверены, что хотите отправить письмо?" @confirm="confirmSend"/>
        <SendError1Window :letter="failedLetter"/>
        <SendError2Window :addressee-list="addresseeList" :letter="failedLetter" @resendLetter="sendLetterToAddressee"/>
        <SendError3Window :social-list="socialList" :letter="failedLetter" @resendLetter="sendLetterToEmail"/>
        <SendError4Window :addressee-list="addresseeList" :letter="failedLetter" :social-list="socialList"
                          @resendLetterToNewEmail="sendLetterToEmail" @resendLetterToAddressee="sendLetterToAddressee"/>

        <div class="step-heading">
            <div class="step-checked-icon"></div>
            <div class="step-number">Шаг 3</div>
            <div class="step-title">Проверка Клиента</div>
        </div>
        <div class="step-content">
            <div class="step-desc">
                У&nbsp;Клиента есть {{ letters.length }}&nbsp;{{ mailLabel }} к&nbsp;отправке
            </div>
            <div class="step-mails">

                <div v-for="letter in letters" class="step-mails-item">
                    <div class="row">
                        <div class="step-mails-icon">
                            <EmailIcon/>
                        </div>
                        <div class="step-mails-title">{{ letter.topic }}</div>
                        <div class="step-mails-button">
                            <button v-if="letter.sendStatus === 'not_sent'"
                                    class="step-button-send modal-client-check-send"
                                    @click="sendLetter(letter)"
                            >
                                Отправить письмо
                            </button>

                            <div v-if="letter.sendStatus === 'success'" class="send-status">Письмо отправлено</div>

                            <a href="#" v-if="letter.sendStatus === 'failed' || letter.sendStatus === 'failed_retry'"
                               class="send-status modal-client-check-send-error" @click.prevent="resendLetter(letter)">Не удалось
                                отправить письмо</a>
                        </div>
                    </div>

                    <div class="step-mails-contacts">
                        <div class="step-mails-contacts-item">
                            <div class="label">Email получателя:</div>
                            <div class="list">
                                <div class="item" v-for="email in recepientMails(letter.recepientList)">
                                    {{ email }}</div>
                            </div>
                        </div>
                        <div class="step-mails-contacts-item" v-if="letter.receiverPhone != null">
                            <div class="label">Номер телефона получателя:</div>
                            <div class="list">
                                <div class="item">{{ letter.receiverPhone }}</div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
import EmailIcon from "@/components/icons/EmailIcon";
import rest from "../../restUtils";
import ConfirmWindow from "@/components/windows/ConfirmWindow";
import SendError2Window from "@/components/windows/SendError2Window";
import SendError3Window from "@/components/windows/SendError3Window";
import SendError4Window from "@/components/windows/SendError4Window";
import SendError1Window from "@/components/windows/SendError1Window";

export default {
    name: "ThirdStep",
    components: {
        SendError1Window,
        SendError4Window, SendError3Window, SendError2Window, ConfirmWindow, EmailIcon
    },
    props: ['addresseeList'],
    data() {
        return {
            letters: [],
            windowText: '',
            recepientList: '',
            failedLetter: {},
            socialList: []
        }
    },
    async created() {
        this.letters = await rest.doGet("/admin/client/" + this.$route.query.id + "/mail");
    },

    computed: {
        mailLabel() {
            let n = this.letters.length;
            n = Math.abs(n) % 100; var n1 = n % 10;
            if (n > 10 && n < 20) { return 'писем'; }
            if (n1 > 1 && n1 < 5) { return 'письма'; }
            if (n1 == 1) { return 'письмо'; }
            return 'писем';
        }
    },

    methods: {
        sendLetter(letter) {
            this.letterToSend = letter;
            $('.dev_confirm_window').addClass('window-open');
            $('body').addClass('blocked');
        },
        async confirmSend() {
            let response = await rest.doPost("/admin/client/" + this.$route.query.id + "/mail?letterId=" + this.letterToSend.id);
            this.letterToSend.sendStatus = response.sendStatus;
            this.letterToSend.recepientList = response.recepientList;

            this.resendLetter(response);
        },
        resendLetter(letter) {
            this.letterToSend = letter;
            if (letter.sendStatus === 'failed') {
                this.failedLetter = letter;
                $('.window-client-check-error').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.agreement && letter.socialList !== '') {
                this.failedLetter = letter;
                this.socialList = letter.socialList.split(",");
                $('.window-client-check-error-4').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.agreement) {
                this.failedLetter = letter;
                $('.window-client-check-error-2').addClass('window-open');
                $('body').addClass('blocked');
            } else if (letter.sendStatus === 'failed_retry' && letter.socialList !== '') {
                this.failedLetter = letter;
                this.socialList = letter.socialList.split(",");
                $('.window-client-check-error-3').addClass('window-open');
                $('body').addClass('blocked');
            }
        },
        async sendLetterToAddressee(letter, addresseeId) {
            let response = await rest.doPost("/admin/client/" + this.$route.query.id + "/mail/resendAddressee?letterId=" + letter.id + "&addresseeId=" + addresseeId);
            this.letterToSend.sendStatus = response.sendStatus;
            this.letterToSend.recepientList = response.recepientList;

            this.resendLetter(response);
        },
        async sendLetterToEmail(letter, newEmails) {
            let emails = newEmails.join(",");
            let response = await rest.doPost("/admin/client/" + this.$route.query.id + "/mail/resendNewMail?letterId=" + letter.id + "&newEmails=" + emails);
            this.letterToSend.sendStatus = response.sendStatus;
            this.letterToSend.recepientList = response.recepientList;

            this.resendLetter(response);
        },

        recepientMails(listString) {
            let mails = listString.split(",");

            let result = [];

            for (let i = 0; i < mails.length; i++) {
                let index = mails[i].lastIndexOf('@');
                let substr = ''
                if (index < 2) {
                    substr = mails[i].substring(0, index);
                } else {
                    substr = mails[i].substring(2, index - 1);
                }
                let repl = '';
                for (let j = 0; j < substr.length; j++) {
                    repl += '*';
                }
                let email = mails[i].replace(substr, repl);
                result.push(email);

            }

            return result;
        }
    }
}
</script>

<style scoped>

</style>